import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ExpressTestByRequestDto } from "../../../../shared/models/express-test/express-test-by-request.dto";
import { KeyValueObject } from "../../../../shared/models/core/KeyValueObject";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { RequestType } from "../../../../shared/enums";

@Component({
    selector: 'agreement-water-analysis-indicators',
    templateUrl: './agreement-water-analysis-indicators.component.html',
    styleUrls: [
        './agreement-water-analysis-indicators.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
    ]
})
export class AgreementWaterAnalysisIndicatorsComponent implements OnInit, OnChanges {

    @Input() test: ExpressTestByRequestDto;
    @Input() creating: boolean = false;
    @Input() editing: boolean = false;
    @Input() performerUsers: KeyValueObject[] = [];
    @Input() dataSaving: boolean;
    @Input() excludedCompleteDates: Date[] = [];
    @Input() canEdit: boolean = true;

    @Output() onCancelEvent: EventEmitter<ExpressTestByRequestDto> = new EventEmitter<ExpressTestByRequestDto>();
    @Output() onEditEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onContinueEvent: EventEmitter<ExpressTestByRequestDto> = new EventEmitter<ExpressTestByRequestDto>();

    public dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    testJson: string;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.test) {
            this.testJson = JSON.stringify(this.test);
        }
    }

    ngOnInit(): void {
        this.testJson = JSON.stringify(this.test);
    }

    cancel() {
        this.test = JSON.parse(this.testJson);
        this.test.completeDateValue = new Date(this.test.completeDateValue);
        this.onCancelEvent.emit(this.test);
    }

    continue() {
        this.onContinueEvent.emit(this.test);
    }

    edit() {
        this.testJson = JSON.stringify(this.test);
        this.onEditEvent.emit();
    }

    get canSaveTest(): boolean {
        return this.test.performerUserId != null && this.isUniqueDate;
    }

    get isUniqueDate(): boolean {
        let testDate = this.test.completeDateValue;
        return this.test.requestId != null || 
            (testDate != null && 
            this.excludedCompleteDates != null &&
            !this.excludedCompleteDates.some(x => 
                x.getFullYear() == testDate.getFullYear() &&
                x.getMonth() == testDate.getMonth() &&
                x.getDate() == testDate.getDate()));
    }

    get isLaboratoryRequestTest() {
        return this.test != null && this.test.requestTypeId == <number>RequestType.laboratory;
    }
}